/*
Todo: Refactor to use CSS-variables instead of hardcoded values

Before 'semantic tokens' the vizColors were created using 'lighten' from 'polished'
This is the old implementation, for reference.

import { lighten } from 'polished';
const lighten40 = lighten(0.4);
const lighten50 = lighten(0.5);

const vizBlue40 = 'lighten40(blue35)'

Since semanticTokens are reading from CSS-variables this will no longer work.

When FireFox reach version 128 (expected july 2024) it will support usage of CSS-rules for the same
Then we will be able to do this:

const cssLighten = ((colorVar: string, luminance: number) => {
  return `hsl(from ${colorVar} h s calc(l + ${luminance}))`
});

const vizBlue40 = cssLighten(blue35, 40);

*/
export const vizBlue40 = '#98c0eb'; // blue35 @ 40% lighten
export const vizBlue50 = '#c3daf3'; // blue35 @ 50% lighten

export const vizGray0 = '#fcfcfc'; // Hardcoded
export const vizGray20 = '#dadada'; // Hardcoded

export const vizGreen40 = '#90e9d1'; // green35 @ 40% lighten
export const vizGreen50 = '#bbf1e3'; // green35 @ 50% lighten

export const vizPink40 = '#f099b8'; // pink35 @ 40% lighten
export const vizPink50 = '#f7c5d7'; // pink35 @ 50% lighten

export const vizPurple40 = '#e599e6'; // purple35 @ 40% lighten
export const vizPurple50 = '#efc2f0'; // purple35 @ 50% lighten

export const vizRed40 = '#ea9f9f'; // red35 @ 40% lighten
export const vizRed50 = '#f3c9c9'; // red35 @ 50% lighten

export const vizYellow40 = '#fed890'; // yellow35 @ 40% lighten
export const vizYellow50 = '#feeac3'; // yellow35 @ 50% lighten

export const vizFilterGray = '#D4DAE3'; // grey80
export const vizFilterLightGray = '#F7F7F9'; // Hardcoded

export const vizSilver = '#C0C0C0'; // Hardcoded

export const vizSettingsBarGray = '#64747B';
